import { template as template_dc5c80bbc4274c91a6f514310efe819a } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { uniqueId } from '@ember/helper';
import { or } from 'ember-truth-helpers';
import { checkedVal } from 'eflex/helpers';
export default class CheckboxInput extends Component {
    onChange = (val)=>{
        this.args.onChange?.(val);
    };
    static{
        template_dc5c80bbc4274c91a6f514310efe819a(`
    <div class="form-check" ...attributes>
      {{#let (or @name (uniqueId)) as |uid|}}
        <input
          id={{uid}}
          class="form-check-input pointer {{@formValidationClass}}"
          type="checkbox"
          checked={{@checked}}
          disabled={{@disabled}}
          indeterminate={{@indeterminate}}
          {{on "change" (checkedVal this.onChange)}}
        />
        {{#if @label}}
          <label for={{uid}} class="form-check-label pointer {{@labelClass}}">
            {{@label}}
          </label>
        {{/if}}
      {{/let}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
